// src/Pages/UserActivityPage/UserActivityPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation }    from 'react-router-dom';
import { useTranslation }              from 'react-i18next';
import UserActivities             from '../../Components/UserActivities/UserActivities';
import { useDirectionByLanguage }      from '../../hooks/useDirectionByLanguage';
import { useHamburgerMenu }            from '../../Contexts/HamburgerMenuContext';
import UserService                     from '../../Services/user.service';

export default function UserActivityPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n, t } = useTranslation();
  const direction = useDirectionByLanguage(i18n);

  const { setMenuProps } = useHamburgerMenu();

  const [user, setUser]     = useState(null);
  const [token, setToken]   = useState('');
  const [accountantId, setAccountantId] = useState(null);

  // update the side‐menu (show page title, etc)
  useEffect(() => {
    setMenuProps({
      title: t('User Activity'),
      // you can add icon, breadcrumbs, etc here
    });
  }, [setMenuProps, t]);

  // load current user & token
  useEffect(() => {
    (async () => {
      try {
        const currentUser  = await UserService.getCurrentUser();
        const currentToken = await UserService.getCurrentToken();
        if (!currentUser || !currentToken) {
          navigate('/login');
          return;
        }
        setUser(currentUser);
        setToken(currentToken);

        // if caller passed an accountantId in location.state, use it:
        if (location.state?.accountantId) {
          setAccountantId(location.state.accountantId);
        } else if (currentUser.accountantId) {
          // fallback: maybe the user object carries it
          setAccountantId(currentUser.accountantId);
        }
      } catch (err) {
        navigate('/login');
      }
    })();
  }, [location.state, navigate]);

  if (!user || !token) return null;

  return (
    <UserActivities
      user={user}
      token={token}
      accountantId={accountantId}
      direction={direction}
    />
  );
}
